module.exports = __webpack_public_path__ + "browser.ec041840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/browser.png
// module id = 1526
// module chunks = 0